import React, { useState } from 'react';

// context
import UserContext from '../context/UserContext';

// auth
import AuthService from '../services/auth.service';

function UserProvider({ children }) {
  const userIsLogin = AuthService.isLogin();
  const [, setUserProfile] = useState({});
  const [userisLogout, setUserLogout] = useState({ isLogout: false });

  const setProfile = (profile) => {
    setUserProfile(profile);
  };

  const setLogout = () => {
    AuthService.logout();
    setUserLogout(true);
  };

  const currentUser = AuthService.getCurrentUser();
  const userProfiles = userIsLogin ? currentUser.profile : '';
  const userTokens = userIsLogin ? currentUser.token : '';

  return (
    <UserContext.Provider
      value={{
        userProfile: userProfiles, setProfile, userIsLogin, setLogout, userisLogout, userToken : userTokens
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export default UserProvider;
